export default __webpack_public_path__ + "static/media/down_arrow.3f2908ad.svg";